import type { GridColumnGroupingModel } from '@repo/go-table';
import { useMemo } from 'react';

import { TableHeader } from '../components/TableHeader/TableHeader';

import { FIELD_TO_MANUAL_ANOMALY_COLUMN_TITLE_KEY } from './FIELD_TO_MANUAL_ANOMALY_COLUMN_TITLE_KEY';

export const MANUAL_ANOMALIES_COLUMN_GROUPS = [
  {
    groupId: 'anomalyTypeGroup',
    children: ['anomalyTypeId', 'anomalySubtypeId'],
  },
  {
    groupId: 'valueGroup',
    children: ['limitValue', 'factValue'],
  },
  {
    groupId: 'deltaGroup',
    children: ['deltaAbsolute', 'deltaRelative'],
  },
] as const;

export const MANUAL_ANOMALIES_GROUPED_COLUMN_FIELDS = new Set<string>(
  MANUAL_ANOMALIES_COLUMN_GROUPS.flatMap((group) => group.children),
);


export const useColumnGroups = () => {
  return useMemo(
    (): GridColumnGroupingModel => [
      {
        groupId: MANUAL_ANOMALIES_COLUMN_GROUPS[0].groupId,
        children: MANUAL_ANOMALIES_COLUMN_GROUPS[0].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return (
            <TableHeader
              field={'anomalyTypeGroup'}
              textTKey={FIELD_TO_MANUAL_ANOMALY_COLUMN_TITLE_KEY['anomalyTypeGroup']}
            />
          );
        },
      },
      {
        groupId: MANUAL_ANOMALIES_COLUMN_GROUPS[1].groupId,
        children: MANUAL_ANOMALIES_COLUMN_GROUPS[1].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'valueGroup'} textTKey={FIELD_TO_MANUAL_ANOMALY_COLUMN_TITLE_KEY['valueGroup']} />;
        },
      },
      {
        groupId: MANUAL_ANOMALIES_COLUMN_GROUPS[2].groupId,
        children: MANUAL_ANOMALIES_COLUMN_GROUPS[2].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'deltaGroup'} textTKey={FIELD_TO_MANUAL_ANOMALY_COLUMN_TITLE_KEY['deltaGroup']} />;
        },
      },
    ],
    [],
  );
};
